<template>
  <div>
    <ca-heading text="Cadastro de Sindicato" />

    <ca-page>
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :is-valid.sync="isFormValid"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col size="6">
            <ca-field label="Nome">
              <ca-input
                v-model="union.name"
                maxlength="60"
                required></ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="CNPJ">
              <cnpj-input v-model="union.register" required></cnpj-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Código Sindical">
              <ca-input
                v-model="union.code"
                maxlength="45"
                required></ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Tipo de divisão de Médias">
              <ca-select v-model="union.monthAvgDivisionType.name" required>
                <ca-option
                  v-for="option in misc.averageUnionsDivisions"
                  :key="option.name"
                  :value="option.name">
                  {{ option.description }}
                </ca-option>
              </ca-select>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Mês da data base da categoria">
              <ca-number-input
                v-model="union.categoryBaseDateDay"
                :custom-validations="monthIsValid"
                required />
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Quantidade de meses em média de Férias">
              <ca-input
                v-model="union.vacationMonthAvg"
                v-mask="'##'"
                type="number"
                min="1"
                max="12"></ca-input>
            </ca-field>
          </ca-col>
          <ca-col size="6">
            <ca-field label="Quantidade de meses em média de 13º">
              <ca-input
                v-model="union.thirteenMonthAvg"
                v-mask="'##'"
                type="number"
                min="1"
                max="12"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Quantidade de meses em média de Aviso Prévio">
              <ca-input
                v-model="union.noticeTerminationMonthAvg"
                v-mask="'##'"
                type="number"
                min="1"
                max="12"></ca-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Percentual Adicional Noturno Diferenciado">
              <percent-input v-model="union.nightShiftPremiumPct">
              </percent-input>
            </ca-field>
          </ca-col>

          <ca-col size="6">
            <ca-field label="Compartilhado">
              <ca-checkbox v-model="union.shared"></ca-checkbox>
            </ca-field>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <ca-submit-button>
                Salvar
              </ca-submit-button>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import { getBoxInformationErrorMessage, initFormObject } from 'packages/common/utils';
import {
  getUnion, createNewUnion, editUnion,
} from './unionService';

export default {
  name: 'UnionsFormPage',
  props: {
    isValid: Boolean,
    object: Object,
    isModal: Boolean,
  },
  data() {
    return {
      isFormValid: false,
      unionId: this.$route.params.id,
      union: {
        ...initFormObject([{ monthAvgDivisionType: 'M' }]),
        vacationMonthAvg: 12,
        thirteenMonthAvg: 12,
        noticeTerminationMonthAvg: 12,
      },
      showLoading: false,
      errorMessage: null,
      monthIsValid: [{
        message: 'Deve ser entre 1 e 12',
        valid(value) {
          return value >= 1 && value <= 12;
        },
      }],
    };
  },
  computed: {
    hasUnionId() {
      return this.unionId;
    },
    misc() {
      return this.$store.state.misc;
    },
  },
  watch: {
    isFormValid(isValid) {
      if (this.isModal) {
        this.$emit('update:isValid', isValid);
      }
    },
    union(value) {
      if (this.isModal) {
        this.$emit('update:object', value);
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    initData() {
      this.$store.dispatch('misc/getAverageUnionsDivisions');

      if (this.hasUnionId && !this.isModal) {
        this.setUnion();
      }
    },
    async setUnion() {
      this.showLoading = true;
      try {
        this.union = await getUnion(this.unionId);
      } finally {
        this.showLoading = false;
      }
    },
    setNightShiftPremiumPct(nightShiftPremiumPct) {
      this.union.nightShiftPremiumPct = nightShiftPremiumPct;
    },
    goBack() {
      this.$router.back();
    },
    onSubmit() {
      return this.hasUnionId
        ? editUnion(this.unionId, this.union)
        : createNewUnion(this.union);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      this.errorMessage = getBoxInformationErrorMessage(error);
    },
  },
};
</script>
